// extracted by mini-css-extract-plugin
module.exports = {"root":"Copyable_qmee_root__zS0re","label":"Copyable_qmee_label__ljaf2","text":"Copyable_qmee_text__BjURW","icon":"Copyable_qmee_icon__xdGVY"};